import { ActivatedRouteSnapshot, Router } from '@angular/router';

export function getRouterShareId(router: Router): string | null {
    return collectRouteParams(router)['shareId'] ?? null;
}

function collectRouteParams(router: Router): Record<string, string> {
    let params: Record<string, string> = {};

    const stack: ActivatedRouteSnapshot[] = [router.routerState.snapshot.root];

    while (stack.length > 0) {
        const route = stack.pop();
        if (route === undefined) {
            continue;
        }

        params = { ...params, ...route.params };

        stack.push(...route.children);
    }

    return params;
}
